const tasks = {
    tasks:'Tareas',
    addNewTask:'Agregar nueva tarea',
    dashboardView:'Vista del panel',
    completedTasks:'Tareas Completadas',
    inCompleteTasks:'Tareas incompletas',
    overdueTasks:'Tareas atrasadas',
    totalTasks:'Tareas totales',
    createAppointment:'Crear Cita',

    tasksModal:{
        addTask:'Agregar tarea',
        title:'Título',
        longDescription:'descripción larga',
        priority:'Prioridad',
        assignedTo:'Asignado a',
        category:'Categoría',
        startDate:'Fecha de inicio',
        dueDate:'Fecha de vencimiento',

    }


  }


export default tasks